// extracted by mini-css-extract-plugin
module.exports = {"priceArea":"price_priceArea__38A4r","price":"price_price__3b1Mo","dash":"price_dash__2qhWn","interval":"price_interval__qqweh"};